import { connect } from 'react-redux';
import PlanSummary from '../../components/Plans/Summary/Summary';
import HomeAction from '../actions/HomeAction';
import { PlansSelector } from '../reducers/PlansReducer';
import { HomeSelector } from '../reducers/HomeReducer';
import { ConfigSelector } from '../reducers/ConfigReducer';

const mapStateToProps = state => ({
  address: HomeSelector.getFullAddress(state),
  technologyType: PlansSelector.getTechnologyType(state),
  contractType: PlansSelector.getContractType(state),
  basePrice: PlansSelector.getBasePrice(state),
  selectedPlan: PlansSelector.getSelectedPlan(state),
  modemPrice: PlansSelector.getModemPrice(state),
  shippingPrice: PlansSelector.getShippingPrice(state),
  connectionPrice: PlansSelector.getConnectionPrice(state),
  isContractSelected: PlansSelector.getIsContractSelected(state),
  ufbAvailable: PlansSelector.getUfbAvailable(state),
  ufbReady: PlansSelector.getUfbReady(state),
  giftWithPurchase: ConfigSelector.getGiftWithPurchase(state),
  discount: ConfigSelector.getDiscount(state),
  discountWithSubscription: ConfigSelector.getDiscountWithSubscription(state),
  withMobileDiscount: PlansSelector.checkWithMobileDiscount(state),
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state),
  isImportantInfoTickbox: PlansSelector.getIsImportantInfoTickboxSelected(state),
  byoModemDiscountPrice: PlansSelector.getByoModemDiscountPrice(state)
});

const mapDispatchToProps = dispatch => ({
  resetAddressSearch: () => {
    dispatch(HomeAction.resetAddressSearch());
  }
});

const PlanSummaryContainer = connect(mapStateToProps, mapDispatchToProps)(PlanSummary);

export default PlanSummaryContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/PlanSummaryContainer.js
 **/